import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { translationHookOptions } from "../../app/localization/localization";
import { Button, Card, UncontrolledTooltip, Row, Col } from "reactstrap";
import GenericConfirmModal from "./GenericConfirmModal";
import { RootStore, RootStoreContext } from "../../app/stores/rootStore";
import GenericModal from "./GenericModal";
interface IParams {
  titleNode: string;
  link?: string;
  className?: string;
  PresentationId: number

}

const TreeDocElement: React.FC<IParams> = ({ titleNode, link,PresentationId, className }) => {
  const [t] = useTranslation(["translation"], translationHookOptions);
  const rootStore = useContext(RootStoreContext);
  const { deletePresentation ,loadRepository} = rootStore.presentationStore;
  const [isModalDelete, setIsModalDelete] = useState(false);

  const formatTitleDiv = (title: string) => {
    return (
      <div className={classNames(`treeDocElement ${className}`, title ? "" : "font-italic")}>
        {title ? title : t("empty_title_node")}
      </div>
    );
  };
  
const handlerDeletePresentation = (PresentationId: number) => {
  setIsModalDelete(true)
}

// il bottone delete a destra è stato gestito nel browsePage.scss 
/* 
.treeDocElement {
  overflow-wrap: break-word !important;
  white-space: pre-wrap !important;
  max-width: calc(95% - 70px) !important;
}
/ serve per rendere visibile il bottone di eliminazione di un elemento dell'albero
.rc-tree-treenode.rc-tree-treenode-switcher-open {
  display: flex !important;
}
.btndeleteTreeElement {
  position: absolute;
  right: 0; 
  top: 50%; 
  transform: translateY(-50%);
}
*/
  return (
    <>
      {(PresentationId>0 )? (
        <>
        <div className="odgElement">
          {link ? <Link to={link}>{formatTitleDiv(titleNode)}</Link> : formatTitleDiv(titleNode)}
           </div>
            <Button
               id={`btnDelete_${PresentationId}`}
               color="link"
               onClick={() =>{handlerDeletePresentation(PresentationId)}}
               className="btndeleteTreeElement specificCss"
             >
          <i className="fas fa-trash-alt fa-lg text-default iconBoxList"></i>
             </Button>
          </>
      ) : (
        <>
        <div className="odgElement">{formatTitleDiv(titleNode)}</div>
        </>
      )}
      {/* <GenericConfirmModal 
      showCancelButton={true}
            messages={t("messagge_deletePresentation",{title: titleNode})}
           title={t("titleModalDelete")} 
           isOpen={isModalDelete} 
          toggle={ ()=>setIsModalDelete(!isModalDelete)} 
           action={()=> { deletePresentation(PresentationId).then(() =>loadRepository()).catch()}}>

       </GenericConfirmModal> */}
   
   <GenericModal 
   isOpen={isModalDelete} 
   toggle={()=> setIsModalDelete(!isModalDelete)}
      content={<>
    <div  className="labelBreakSpace">
        {t("messagge_deletePresentation",{title: titleNode})}
      </div>
      </>}
      title={t("titleModalDelete")} 
      actions={[{
        text: "OK",
        action: async () => {
          await deletePresentation(PresentationId).then(() => loadRepository()).catch()
          setIsModalDelete(false);
        },
        color : "secondary"
        },{
          text: t("cancel"),
          action: () => {
            setIsModalDelete(false);
          },
          color : "secondary"
          }]}
      >

   </GenericModal>
   
   
    </>
  );
};

export default observer(TreeDocElement);
